import * as React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Typography, Box, Container, Grid } from '@mui/material';
import Divider from '@mui/joy/Divider';
import Input from '@mui/joy/Input';
import Checkbox from '@mui/joy/Checkbox';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { footerStyles } from './Components/styles';
import ScrollAnimation from './Components/ScrollAnimation';

export default function Footer() {

    return (
        <>

            <Box sx={footerStyles}>
                <Container maxWidth="lg">
                    <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'space-between', pt: '60px', pb: '0px' }}>

                        <Grid item xs={12} md={5}>
                            <ScrollAnimation animateIn="flipInX" delay={0.2}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: 1 }}>
                                    <Image src="/logo-main.png" alt="Scriptu" width={600} height={166} style={{ width: '173px', height: '45px' }} priority />
                                </Box>

                                {/*}
                                <Box sx={{ mt: '60px' }}>
                                    <Typography variant="h6" gutterBottom sx={{ fontWeight: '600', lineHeight: 1.6, letterSpacing: '0.0075em', mb: '10px' }}>
                                        Newsletter Signup
                                    </Typography>
                                    <Box className="newsletter-signup">
                                        <Input
                                            placeholder='Enter Your Email Address'
                                            startDecorator={<MailOutlineIcon />}
                                            endDecorator={<ArrowForwardIcon />}

                                        />
                                    </Box>


                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mt: 2, gap: 1, ml: 1 }}>
                                        <Checkbox />
                                        <Typography variant="body2">
                                            <Link href="#" underline="none">
                                                I agree to the Privacy Policy.
                                            </Link>
                                        </Typography>
                                    </Box>
                                </Box>
                                */}
                            </ScrollAnimation>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {/* Center Text */}
                            <Typography variant="h3" gutterBottom sx={{
                                mb: '60px', fontSize: '30px', fontWeight: '700', lineHeight: 1.2, letterSpacing: '-1.2px'
                            }}>

                            </Typography>


                            {/* Socials and Menu Links */}
                            <ScrollAnimation animateIn="flipInX" delay={0.2}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Box>
                                        <Typography variant="h6" sx={{ mb: 2, fontWeight: '600' }}>Socials</Typography>
                                        {/* Repeat Link component for each social link */}
                                        <Typography variant="body2" className="footer-link">
                                            <Link href="https://www.linkedin.com/company/102267198" target="_blank">LinkedIn</Link>
                                        </Typography>
                                    </Box>

                                    {/*
                                    <Box>
                                        <Typography variant="body2" className="footer-link">
                                            <Link href="#">About Us</Link>
                                        </Typography>
                                        <Typography variant="body2" className="footer-link">
                                            <Link href="#">Community</Link>
                                        </Typography>
                                        <Typography variant="body2" className="footer-link">
                                            <Link href="#">Affiliate Program</Link>
                                        </Typography>
                                    </Box>
                                    */}

                                    <Box>
                                        <Typography variant="h6" sx={{ mb: 2, fontWeight: '600' }}>Contact Info</Typography>
                                        {/* Repeat Link component for each menu link */}
                                        <Typography variant="body2" className="footer-link">
                                            <Link href="mailto:contact@scriptu.io">
                                            contact@Scriptu.io</Link>
                                        </Typography>
                                    </Box>
                                </Box>
                            </ScrollAnimation>
                        </Grid>
                    </Grid>
                    <Box sx={{ pb: 3 }}>
                        <Divider sx={{ mt: 10, mb: 3 }} />
                        <ScrollAnimation animateIn="flipInX" delay={0.2}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', ml: 3, mr: 3 }}>
                            <Typography variant="body2" sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px' }}>
                                © {new Date().getFullYear()} Scriptu All Rights Reserved
                            </Typography>

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Link href="/privacy" sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px' }}>Privacy Policy</Link>
                                <Divider orientation="vertical" />
                                <Link href="/terms" sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px' }}>Terms of Service</Link>
                            </Box>
                        </Box>
                        </ScrollAnimation>  
                    </Box>
                </Container>
            </Box>

        </>
    );
}
